<div class="d-flex justify-content-between align-items-center mb-3 sticky-header">
  <div>
    <h4 class="mb-0">
      {{ 'Settings::WorkEnvironment:WrapupCodes:Title' | abpLocalization }}
    </h4>
    <p class="text-muted small mb-0 mt-1">
      {{ 'Settings::WorkEnvironment:WrapupCodes:Subtitle' | abpLocalization }}
    </p>
  </div>
  <button type="button" class="btn btn-primary btn-sm" (click)="openAddDialog()">
    <i class="pi pi-plus me-2"></i>
    {{ 'Settings::WorkEnvironment:WrapupCodes:AddCode' | abpLocalization }}
  </button>
</div>

<app-wrap-up-definition-list
  [reloadVersion]="reloadVersion"
  (edit)="openEditDialog($event)"
  (deleted)="onDeleted()" />

<app-wrap-up-definition-form-dialog
  [visible]="showDialog"
  [codeId]="selectedCodeId"
  [isPredefined]="selectedCodeIsPredefined"
  (visibleChange)="onDialogVisibilityChange($event)"
  (saved)="onSaved()" />
